module.exports = __webpack_public_path__ + "static/img/brid_self.380e73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/brid_self.png
// module id = 9626
// module chunks = 1 3